/** Generate a new passcode for a feed */
export const feedNewPasscodeSpec = {
    uri: '/t/[tenant]/feed/[feed]/new-passcode',
    method: 'POST',
};
